/**
 * Asynchronously loads the component for FeaturePage
 */

import { loadable } from '@elliemae/pui-app-sdk';

export const InvestorRelationships = loadable(
  () =>
    import(
      /* webpackChunkName: "datapage1" */ /* webpackPrefetch: true */ './index'
    ),
);
